var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6664 9.7C26.5274 8.39921 25.8996 6.729 25.8998 5H20.7498V25.6667C20.7109 26.7853 20.239 27.8451 19.4336 28.6225C18.6283 29.3999 17.5524 29.834 16.4331 29.8333C14.0664 29.8333 12.0998 27.9 12.0998 25.5C12.0998 22.6333 14.8664 20.4833 17.7164 21.3667V16.1C11.9664 15.3333 6.93311 19.8 6.93311 25.5C6.93311 31.05 11.5331 35 16.4164 35C21.6498 35 25.8998 30.75 25.8998 25.5V15.0167C27.9881 16.5164 30.4954 17.3211 33.0664 17.3167V12.1667C33.0664 12.1667 29.9331 12.3167 27.6664 9.7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.c1eb9d913e3184749d2eb9d9a6b544a0.svg";
export { ForwardRef as ReactComponent };